import { render } from "./sales-customers.vue?vue&type=template&id=b030a88a"
import script from "./sales-customers.vue?vue&type=script&lang=js"
export * from "./sales-customers.vue?vue&type=script&lang=js"

import "./sales-customers.vue?vue&type=style&index=0&id=b030a88a&lang=css"

import exportComponent from "/home/gerind/Desktop/work/gobe-system/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__